import ProgressCard from '../../../../../common/card/ProgressCard'
import Link from '../../../../../common/link/Link'
import { useCourseReport } from '../../../ReportingGroup/context/CourseReportContext'
import { useUserReport } from '../../../ReportingGroup/context/UserReportContext'
import { getLastActivity } from '../../../ReportingGroup/utils'

const UserQuizStats = ({ from }) => {
    const { selectedUser, selectedQuiz } = from === 'course-report' ? useCourseReport() : useUserReport()
    
    const certificateLink = selectedQuiz.quizCertificateLink ?? ''

    const lastActivity = getLastActivity( selectedUser )

    return (
        <div className='msync-reporting__detail__overview msync-report-user-profile'>
            <div className='msync-reporting__detail__overview__content msync-report-user-profile__user'>
                <span className='msync-report-user-profile__title'>Profile</span>
                <div className="msync-report-user-profile__user__content">
                    <div className='msync-report-user-profile__user__img'>
                        <img src={selectedUser.avatarUrl} alt="msync_user_profile" />
                    </div>
                    <div className='msync-report-user-profile__user__details'>
                        <span className='msync-report-user-profile__user__details__fullname'>{ selectedUser.name }</span>
                        <span className='msync-report-user-profile__user__details__email'>{ selectedUser.email }</span>
                        <span className='msync-report-user-profile__user__details__last-seen'>{ lastActivity }</span>
                    </div>
                </div>
            </div>
            <div className='msync-report-user-profile__progress'>
                <span className="msync-report-user-profile__title">Quiz Summary</span>
                <div className="msync-report-user-profile__progress__content msync-report-user-profile__progress__horizontal">
                    <ProgressCard content={{ 
                        title: 'score',
                        color: '#0E9F6E',
                        value: `${selectedQuiz.quizScore ?? 0} %`
                     }} />
                     <ProgressCard content={{ 
                        title: 'date completed',
                        value: selectedQuiz.dateCompleted ?? ''
                     }} />
                </div>
            </div>
            <div className="msync-report-user-profile__content">
                <span className="msync-report-user-profile__title">Content</span>
                <div className="msync-report-user-profile__content__inner">
                    <Link 
                        className={`msync-button msync-button--is-style-outline`} 
                        link={certificateLink === "" ? false : certificateLink }
                        target={'_blank'}
                        disabled={certificateLink === "" ? true : false }
                    >
                        Download Certificate
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default UserQuizStats